<template>
  <transition name="banner-slide">
    <div v-if="visible" :class="['login-banner', { urgent: hasUrgent }]">
      <div class="lb-content">
        <i
          :class="hasUrgent ? 'el-icon-warning' : 'el-icon-info'"
          class="lb-icon"
        ></i>
        <span class="lb-text">{{ bannerText }}</span>
      </div>
      <div class="lb-actions">
        <button class="lb-btn-primary" @click="openDrawer">Ver ahora</button>
        <button class="lb-btn-ghost" @click="dismiss">Luego</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "LoginBanner",
  data() {
    return {
      dismissed: false,
      autoHideTimer: null
    };
  },
  computed: {
    loginContext() {
      return this.$store.state.notificationsStore.loginContext;
    },
    hasUrgent() {
      return this.loginContext ? this.loginContext.has_urgent : false;
    },
    visible() {
      if (this.dismissed) return false;
      if (!this.loginContext || !this.loginContext.show_banner) return false;
      // Check localStorage for today's dismiss
      const user = this.$store.getters.getUser;
      const today = new Date().toISOString().slice(0, 10);
      const key = `notif_banner_${user.id || "0"}_${today}`;
      return localStorage.getItem(key) !== "dismissed";
    },
    bannerText() {
      if (!this.loginContext) return "";
      const days = this.loginContext.days_since_last;
      const count = this.loginContext.total_pending;
      if (days >= 5) {
        return `Llevas ${days} dias sin ingresar. Tienes ${count} notificacion${
          count !== 1 ? "es" : ""
        } pendiente${count !== 1 ? "s" : ""}.`;
      }
      return `Tienes ${count} notificacion${count !== 1 ? "es" : ""} pendiente${
        count !== 1 ? "s" : ""
      }.`;
    }
  },
  mounted() {
    // Auto-hide after 30 seconds
    this.autoHideTimer = setTimeout(() => {
      this.dismissed = true;
    }, 30000);
  },
  beforeDestroy() {
    if (this.autoHideTimer) clearTimeout(this.autoHideTimer);
  },
  methods: {
    openDrawer() {
      this.$store.dispatch("notificationsStore/openDrawer");
      this.dismiss();
    },
    dismiss() {
      this.dismissed = true;
      const user = this.$store.getters.getUser;
      const today = new Date().toISOString().slice(0, 10);
      const key = `notif_banner_${user.id || "0"}_${today}`;
      localStorage.setItem(key, "dismissed");
    }
  }
};
</script>

<style lang="scss" scoped>
$primary: #31355c;
$accent: #3ecfb4;
$border: #e4eaf6;

.login-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 24px;
  background: #fff;
  border: 1px solid $border;
  border-left: 3px solid #ba7517;
  margin: 12px 24px 0;
  border-radius: 8px;
  gap: 12px;
  flex-wrap: wrap;
  &.urgent {
    border-left-color: #e24b4a;
  }
}
.lb-content {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}
.lb-icon {
  font-size: 16px;
  color: #ba7517;
  flex-shrink: 0;
  .urgent & {
    color: #e24b4a;
  }
}
.lb-text {
  font-size: 13px;
  color: $primary;
  font-weight: 500;
}
.lb-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.lb-btn-primary {
  font-size: 12px;
  font-weight: 600;
  padding: 5px 14px;
  background: $primary;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.12s;
  &:hover {
    opacity: 0.9;
  }
}
.lb-btn-ghost {
  font-size: 12px;
  font-weight: 500;
  padding: 5px 14px;
  background: transparent;
  color: #909399;
  border: 1px solid $border;
  border-radius: 6px;
  cursor: pointer;
  &:hover {
    background: #f7f8f9;
    color: $primary;
  }
}

// Transition
.banner-slide-enter-active,
.banner-slide-leave-active {
  transition: max-height 0.3s, opacity 0.3s, margin 0.3s;
  overflow: hidden;
  max-height: 80px;
}
.banner-slide-enter,
.banner-slide-leave-to {
  max-height: 0;
  opacity: 0;
  margin-top: 0;
  margin-bottom: 0;
}
</style>
